import React from "react";
import { useTranslation } from "react-i18next";
import "./websiteBuilderBanner.scss";
import { websiteBuilderZLayers } from "../websiteBuilderZLayers";
import { ButtonNew as Button } from "components/buttonNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop } from "@fortawesome/pro-regular-svg-icons";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderSetDesignMode, websiteBuilderSetPreviewMode } from "redux/actions/websiteBuilder/websiteBuilder";

export function WebsiteBuilderBanner() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const mode = useAppSelector(store => store.websiteBuilderStore.mode);

  function dispatchChangeMode() {
    if (mode === "preview") {
      dispatch(websiteBuilderSetDesignMode());
    } else {
      dispatch(websiteBuilderSetPreviewMode());
    }
  }

  return (
    <div
      className="website-builder-banner"
      style={{
        zIndex: websiteBuilderZLayers.shell.ui,
      }}
    >
      <div></div>
      <div className="website-builder-banner-website-name">Website name</div>
      <div className="website-builder-banner-actions">
        <Button type="text" size="small" onClick={dispatchChangeMode}>
          <FontAwesomeIcon className="website-builder-banner-desktop-icon" icon={faDesktop} />
          {mode === "preview" ? t("Design") : t("Preview")}
        </Button>
        <Button size="small">{t("Publish")}</Button>
      </div>
    </div>
  );
}
